<template>
  <div
    class="d-flex align-items-center"
    :class="[disabled ? 'color-sachlich-darkergrey' : 'checkbox-default']"
    :value="value"
    @click.stop="internalClicked"
  >
    <div 
      v-if="left"
      :style="styleLabelLeft"
    >
      {{ label }}
      <slot />
    </div>

    <div
      class="icon-container border border-2 d-flex align-items-center justify-content-center"
      :class="[
        disabled ? 'disabled color-sachlich-grey-border' : 'border-sachlich-darkergrey', 
        { 'checked bg-expinet-blue border-expinet-blue color-sachlich-white': !!value }
      ]"
    >
      <i 
        v-if="!!value" 
        class="fa fa-check"
      />
    </div>
    <div 
      v-if="!left"
      :style="styleLabelRight"
    >
      {{ label }}
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ClickCallback } from '../callbacks';

export default defineComponent({
  name: 'CheckBox',
  props: {
    disabled: { type: Boolean, default: false },
    checked: { type: Boolean, default: false },
    label: { type: String, default: '' },
    left: { type: Boolean, default: false },
    alignContent: { type: String, default: 'center' },
    weight: { type: String, default: 'normal' },
    clicked: { type: Function as PropType<ClickCallback>, default: () => console.log('clicked not implemented') }, // eslint-disable-line no-console
  },
  emits: ['click'],

  data() {
    return {
      value: this.checked,
    }
  },

  computed: {
    styleLabelLeft() {
      return {
        'font-weight': this.weight,
        padding: '0 5px 0 0',
        'align-self': 'center',
      }
    },
    styleLabelRight() {
      return {
        'font-weight': this.weight,
        padding: '0 0 0 5px',
        'align-self': 'center',
      }
    },
  },

  watch: {
    checked(val) {
      if (!this.disabled) {
        this.value = val
      }
    },
  },

  methods: {
    internalClicked(event: MouseEvent) {
      if (this.disabled) {
        return
      }

      this.value = !this.value
      this.clicked(event)
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.checkbox-default {
  cursor: pointer;
}

.icon-container {
  width: 20px;
  height: 20px;
}

.icon-container:not(.disabled):hover {
  border-color: $color-expinet-blue !important;
}
</style>
